export default __webpack_public_path__ + "static/media/bicycle.e328721e.svg";